module.exports = __webpack_public_path__ + "media/images/page/scene03-f20492237b30d844f06be7811d14e93e.jpg";